import React from 'react';
import { Box, Grid } from '@mui/material';
import ComplianceScore from './ComplianceScore';
import PageHeader from '../common/PageHeader';

export default function CompliancePage() {
  return (
    <Box>
      <PageHeader title="Compliance Risk Score" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <ComplianceScore compact={false} />
        </Grid>
      </Grid>
    </Box>
  );
}
